import React from 'react'
import { YoutubeVisibilityLevel } from './constants'
import { ChevronUp } from 'blaze-ui/icons'
import { ChevronDown } from 'blaze-ui/icons/20/ChevronDown'
import type { IconProps } from 'blaze-ui/icons/Types'

export function getDisabledKeyTooltip(key: YoutubeVisibilityLevel) {
  switch (key) {
    case YoutubeVisibilityLevel.Private:
      return 'Branded content visibility cannot be set to private.'
    default:
      return ''
  }
}

export function renderExpandIcon(isOpen: boolean, props: IconProps) {
  return (
    <ChevronUp
      {...props}
      style={{
        transition: 'transform 0.2s',
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
      data-testid="expand-icon"
    />
  )
}

export function renderCollapseIcon(isOpen: boolean, props: IconProps) {
  return (
    <ChevronDown
      {...props}
      style={{
        transition: 'transform 0.2s',
        transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
      }}
      data-testid="collapse-icon"
    />
  )
}
